export const APP = {
  CHURCH_ORG: process.env.REACT_APP_CHURCH_ORG || 'Prosol Church',
};
